var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnlyMedswiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6607 8.70335H17.0604V0.381836H26.315V8.70335H34.6495V17.8076H26.315V23.4253C20.6694 28.6689 17.0669 35.0912 15.021 43.4974H8.7647V35.1997H0.379272V26.002H8.7647V8.70335H14.6607Z",
    fill: "#4576E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6613 8.32179H16.6807V0.381502V0H17.0601H26.3154H26.6948V0.381502V8.32179H34.65H35.0293V8.70329V17.8079V18.1894H34.65H26.6948V23.4245V23.5905L26.5719 23.7045C23.778 26.2994 21.4891 29.1865 19.6469 32.4627C17.8027 35.7428 16.4027 39.4184 15.3884 43.5866L15.3176 43.8787H15.0209H8.7642H8.38488V43.4974V35.5814H0.379322H0V35.1999V26.0015V25.62H0.379322H8.38488V8.70329V8.32179H8.7642H14.6613ZM17.0601 9.08479H14.6613H9.14351V26.0015V26.383H8.7642H0.758634V34.8184H8.7642H9.14351V35.1999V43.1159H14.7254C15.7507 38.9981 17.1533 35.353 18.9893 32.0874C20.844 28.7894 23.1407 25.878 25.9363 23.2593V17.8079V17.4264H26.3154H34.2706V9.08479H26.3154H25.9363V8.70329V0.763004H17.4394V8.70329V9.08479H17.0601Z",
    fill: "#4576E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8121 0.991211H25.5519V9.41H33.9224V17.1942H25.5519L25.5373 23.6409C25.0864 24.0906 24.0651 25.1407 23.6407 25.6082L17.8121 25.613V17.1942H9.44153V9.41H17.8121V0.991211Z",
    fill: "#F54268"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5923 17.6895C29.2646 23.5724 21.8356 31.0146 18.8492 43.8038H30.3774C33.0035 39.5365 35.1161 36.9277 38.6519 35.0966L38.5677 43.6749C40.8583 40.1541 43.8587 37.2205 46.9476 34.9196V43.8566L53.7625 43.899L53.9308 17.7423C50.0188 19.2234 46.3167 21.0008 42.6151 23.6663L42.5923 17.6895Z",
    fill: "#4576E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyMedswiss);
export default __webpack_public_path__ + "static/media/logo_only_medswiss.a0de50711e5dbffff652307c07d8dbe3.svg";
export { ForwardRef as ReactComponent };